export const Marquee = ({ items }) => {
  const list = [...items, ...items];
  return (
    <div className="overflow-hidden border-y border-[#D1CFC7] py-6 bg-[#F4F1EA]" data-testid="genre-marquee">
      <div className="flex animate-marquee whitespace-nowrap">
        {list.map((item, i) => (
          <span
            key={i}
            className="mx-12 font-serif text-3xl md:text-4xl text-[#2C402E] italic"
          >
            {item}
            <span className="ml-12 text-[#9E4735]">✦</span>
          </span>
        ))}
      </div>
    </div>
  );
};
